<template>
<footer>
        <section className="py-4 border-top bg-light">
          <div className="container">
           
            <hr style="color: #000; background: black"/>
                <p className="mb-0 text-center">Copyright © 2021. All right reserved.</p>
          </div>
        </section>
      </footer>
    
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style>

</style>